import { ArrowLeftOutlined } from "@ant-design/icons";
import { Tabs } from "antd";
import React, { useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { setTabsForPersonalInfo } from "../../slices/userSlice";
const onChange = (key) => {
  console.log(key);
};

const OperationsSlot = ({ setAchievement, setActiveTab }) => {
  console.log(setActiveTab, "===asjdabahbsdasbd");
  const dispatch = useDispatch();
  return (
    <button
      // className="m-2 bg-tabsTextStyle rounded-3xl py-1 px-3 text-pureWhite"
      className="mr-5 text-gray-500"
      onClick={() => {
        setAchievement("");
        dispatch(setTabsForPersonalInfo("4"));
      }}
    >
      <ArrowLeftOutlined className="text-lg" />
      {/* Go Back */}
    </button>
  );
};

const MyTab = ({
  setAchievement,
  setSelectedStepher,
  setActiveTab,
  activeTab,
  items,
  ...rest
}) => {
  // const [position, setPosition] = useState(["left"]);
  const slot = useMemo(() => {
    // if (position.length === 0) return null;
    // return position.reduce(
    //   (acc, direction) => ({
    //     ...acc,
    //     [direction]: OperationsSlot(
    //       setAchievement,
    //       // setSelectedStepher,
    //       setActiveTab
    //     ),
    //   }),
    //   {}
    // );
    return {
      ["left"]: (
        <OperationsSlot
          setAchievement={setAchievement}
          // setActiveTab={setActiveTab}
        />
      ),
    };
  }, []);
  console.log("🚀 ~ activeTab:", activeTab);
  return (
    <>
      <Tabs
        className="bg-pureWhite p-5 rounded-3xl"
        {...rest}
        tabBarExtraContent={setAchievement && slot}
        defaultActiveKey={activeTab}
        items={items}
        onChange={onChange}
      />
    </>
  );
};
export default MyTab;
